import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e04a8adc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uf-visitor-form"
}
const _hoisted_2 = { class: "number" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "请填写来访人信息", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "footer-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.number)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, "剩余填写人数" + _toDisplayString($setup.number) + "人", 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_form, { onSubmit: $setup.onSubmit }, {
              default: _withCtx(() => [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.personList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "form-visitor-item",
                    key: item.key
                  }, [
                    (index != 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "form-delete",
                          onClick: ($event: any) => ($setup.deletePerson(index))
                        }, "删除", 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    _createVNode(_component_van_cell_group, { inset: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_field, {
                          modelValue: item.name,
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          maxlength: "20",
                          required: "",
                          name: 'name' + index,
                          label: `来访人${index + 1 < 2 ? '' : index + 1}`,
                          placeholder: `请输入来访人${index + 1 < 2 ? '' : index + 1}姓名`,
                          rules: [{ required: true, message: `请输入姓名` }]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "placeholder"]),
                        _createVNode(_component_van_field, {
                          modelValue: item.mobile,
                          "onUpdate:modelValue": ($event: any) => ((item.mobile) = $event),
                          type: "tel",
                          name: 'mobile' + index,
                          label: "手机号",
                          maxlength: "11",
                          required: "",
                          placeholder: "请输入来访人手机号",
                          rules: [
                  { required: true, message: '请输入手机号' },
                  { pattern: $setup.validate.mobile.reg, message: $setup.validate.mobile.msg }
                ]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]),
                        _createVNode(_component_van_field, {
                          modelValue: item.email,
                          "onUpdate:modelValue": ($event: any) => ((item.email) = $event),
                          type: "email",
                          name: 'email' + index,
                          label: "邮箱",
                          placeholder: "请输入来访人邮箱"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                        _createVNode(_component_van_field, {
                          modelValue: item.car_number,
                          "onUpdate:modelValue": ($event: any) => ((item.car_number) = $event),
                          name: 'car_number' + index,
                          label: "车牌号",
                          placeholder: "请输入车牌号"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128)),
                ($setup.personList.length < $setup.number)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "add-visitor-btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.addPerson && $setup.addPerson(...args)))
                    }, [
                      _createVNode(_component_van_icon, { name: "plus" }),
                      _createTextVNode(" 新增来访人 ")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_van_button, {
                    round: "",
                    block: "",
                    type: "primary",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 提交申请 ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}